import React from "react";

import { CalculatorIcon as Calculator, Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import * as Dropdown from "ds/Dropdown";

import * as S from "./BackupsCostPanel.styles";

const isIncluded = (amount: string = ""): boolean | null => {
  if (!amount) return null;
  const digits = +amount?.replace(/\D+/g, "");
  return digits * 1 === 0;
};
interface PanelProps {
  currency: string;
  hasNoBackupOrDefault: boolean;
  totalBackupsPrice: string;
  storageInGB: number;
  price: string;
  finalBackupPricePerGig: string;
}

const Panel = ({
  currency,
  hasNoBackupOrDefault,
  totalBackupsPrice,
  storageInGB,
  price,
  finalBackupPricePerGig
}: PanelProps) => {
  const intl = useIntl();
  const isBackupsPriceIncluded = isIncluded(totalBackupsPrice);

  return (
    <Dropdown.Root id="backups_cost_panel">
      <S.TriggerStyled variant="icon">
        <Calculator />
      </S.TriggerStyled>
      <Dropdown.Portal>
        <S.DropdownContent align="end">
          <S.DropdownInfoTop>
            <Typography.Title tag="h3">
              {intl.formatMessage({
                id: "backups.panel.header",
                defaultMessage: "Backups cost breakdown"
              })}
            </Typography.Title>
            <S.Description>
              {intl.formatMessage(
                {
                  id: "backups.panel.info",
                  defaultMessage: `${price} per GB of storage on your master environment. Development environments remain on the Default plan.`
                },
                {
                  estimation: price
                }
              )}
            </S.Description>
            <Dropdown.Separator />
            <S.FirstRow>
              <S.Label>
                {intl.formatMessage({
                  id: "backups.storage",
                  defaultMessage: "Storage on Master (in GB)"
                })}
              </S.Label>
              <S.NumberLabel>{storageInGB}</S.NumberLabel>
            </S.FirstRow>
            <S.DropdownRow>
              <S.Label>
                {intl.formatMessage(
                  {
                    id: "backups.cost.perGB",
                    defaultMessage: `Cost per GB (in ${currency})`
                  },
                  {
                    currency
                  }
                )}
              </S.Label>
              <S.Close color="var(--icon-granite-color,var(--granite))" />
              <S.NumberLabel
                className={` ${
                  isBackupsPriceIncluded && !hasNoBackupOrDefault
                    ? "discount"
                    : ""
                }`}
              >
                {finalBackupPricePerGig}
              </S.NumberLabel>
            </S.DropdownRow>
          </S.DropdownInfoTop>

          <S.DropdownInfoBottom>
            <S.Label>
              {intl.formatMessage({
                id: "total_monthly_cost",
                defaultMessage: "Total monthly cost"
              })}
              *
            </S.Label>
            <S.NumberLabel>
              {isBackupsPriceIncluded
                ? intl.formatMessage({
                    defaultMessage: "Default included",
                    id: "default.included"
                  })
                : totalBackupsPrice}
            </S.NumberLabel>
          </S.DropdownInfoBottom>
        </S.DropdownContent>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};

export default Panel;
